import BigSelectInput from './BigSelectInput';

export default BigSelectInput;
